export const timeSheetVI = {
    "timeSheetApp": {
        "first": "Nửa ca đầu",
        "end": "Nửa ca sau",
        "title" : " Bảng chấm công từ " ,
        "to" : " đến ",
        "last": "Nửa ca sau",
    },
    "paid": {
        "true": "Có tính công",
        "false": "Không tính công",
    },
    "punish": {
        "true": "Có phạt tiền",
        "false": "Không  bị phạt",
    },
    "title" : {

    }
}